/* eslint-disable no-mixed-operators */
import React, { Component } from 'react';
import { Carousel, BottomButton } from 'components';
import { LayoutWithBannerNavbarFooter } from 'layouts';
import ultilitiesService from 'shared/util/ultilitiesService';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import background from 'assets/images/risk-profile-bg.png';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { PATH, STORAGE_KEY } from 'shared/constants';
import { toggleLanguage } from 'shared/redux/actions';
import arrowWhite from 'assets/icons/nextWhite.svg';
import { getRTL } from 'shared/redux/selectors';
import Recommendation from './Recommendation';
// import productsData from './data.json';
import './ProductRecommendation.scss';


const statusBarClass = 'status-bar--product-overview';

class ProductRecommendation extends Component {
  state = {
    initialSlide: localStorage.getItem(STORAGE_KEY.CURRENT_PRODUCT_SLIDE) ? Number(localStorage.getItem(STORAGE_KEY.CURRENT_PRODUCT_SLIDE)) : 0,
  }

  componentDidMount() {
    document.body.classList.add(statusBarClass);

    localStorage.removeItem(STORAGE_KEY.CURRENT_PRODUCT_SLIDE);

    const {
      history,
      assetAllocations,
    } = this.props;
    if (!(assetAllocations && assetAllocations.isinCodes.length)) {
      history.push(PATH.ASSETS_ALLOCATION);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(statusBarClass);
  }

  sortFund = (a, b) => {
    const {
      assetAllocations: {
        tacticleAsset,
      },
    } = this.props;
    const fundsISIN = tacticleAsset.filter(item => item.isinCode).map(item => item.isinCode);

    return fundsISIN.indexOf(a.isin) - fundsISIN.indexOf(b.isin);
  };

  render() {
    const {
      intl, funds, currentLocale, history, isRtl,
    } = this.props;

    const { initialSlide } = this.state;

    return (
      <LayoutWithBannerNavbarFooter
        // leftButton={<FontAwesomeIcon icon={faLongArrowAltLeft} />}
        leftButton={(<span className="arrow"><img src={arrowWhite} alt="arrow" /></span>)}
        rightButton={ultilitiesService.locale(currentLocale)}
        onRightClick={() => history.push(PATH.LANGUAGE)}
        title="products.title"
        background={background}
        className="nw-page-products"
        bannerText={<p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'products.bannerText' }, { number: funds && funds.length }) }} />}
        onLeftClick={() => this.props.history.push(PATH.ASSETS_ALLOCATION)}
        isRtl={isRtl}
        footerChildren={(
          <BottomButton value={intl.formatMessage({ id: 'products.backToAssetAllocation' })} onButtonClick={() => this.props.history.push(PATH.ASSETS_ALLOCATION)} isOutlineButton />
        )}
      >
        {funds && funds.length && (
        <Carousel isCenterMode centerPadding="25px" withDots initialSlide={initialSlide}>
          {funds && funds.sort(this.sortFund).map((item, idx) => (
            <Recommendation
              key={item.fundId}
              number={idx + 1}
              banner={item.banner}
              masterData={item}
              etf={item.etf}
              productType={item.productType}
              intl={intl}
            />
          ))}
        </Carousel>
        )}

      </LayoutWithBannerNavbarFooter>
    );
  }
}

const mapStateToProps = state => ({
  funds: state.fundFactsheetReducer.funds,
  assetAllocations: state.assetAllocations,
  currentLocale: state.rootReducer.language.locale,
  isRtl: getRTL(state.rootReducer),
});

const mapDispatchToProps = ({
  onSwitchLanguage: toggleLanguage,
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProductRecommendation));
